import React from "react";
import { Routes, Route } from "react-router-dom";
import Settings from "./containers/Settings";
import PrivacyPolicy from "./containers/Settings/PrivacyPolicy";
import Faq from "./containers/Settings/Faq";

const SettingsRoutes = ({ showSidebar }) => {
  return (
    <Routes>
      <Route path="/settings" element={<Settings showSidebar={showSidebar} />} />
      <Route path="/settings/privacy-policy" element={<Settings showSidebar={showSidebar} />} />
      <Route path="/settings/faq" element={<Settings showSidebar={showSidebar} />} />
    </Routes>
  );
};

export default SettingsRoutes;
